import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { UserContextService } from '../services/user-context.service';

export const appHomeRedirectGuard: CanActivateFn = async () => {
  const userContext = inject(UserContextService);
  const router = inject(Router);
  await userContext.ensureInitialized();
  return userContext.hasOrganizationAccess()
    ? router.createUrlTree(['/app/tickets'])
    : router.createUrlTree(['/app/profile']);
};

export const organizationEmployeeChildGuard: CanActivateChildFn = async (_childRoute, state) => {
  const router = inject(Router);
  const userContext = inject(UserContextService);
  await userContext.ensureInitialized();

  const accountOnlyPaths = new Set(['profile', 'about']);
  const adminOnlyPaths = new Set(['employees']);
  const segment = state.url.split('?')[0].replace(/^\/app\/?/, '').split('/')[0] ?? '';

  if (accountOnlyPaths.has(segment)) return true;
  if (!userContext.hasOrganizationAccess()) return router.createUrlTree(['/app/profile']);
  if (adminOnlyPaths.has(segment) && !userContext.isAdmin()) {
    return router.createUrlTree(['/app/tickets']);
  }
  return true;
};
